<div class="go-search">
  <div class="go-search__container"
       [ngClass]="{ 'go-search__container--active': searchActive, 'go-search__container--results': goSearchService.hasResults }">
    <form [formGroup]="goSearchForm"
          class="go-search__field">
      <button class="go-search__submit" type="button">
        <go-icon icon="search" class="go-search__icon"></go-icon>
      </button> 
      <input class="go-search__input" 
             placeholder="Search..."
             (focus)="toggleActive()"
             (blur)="leaveInput($event)"
             (keydown)="keyDown($event)"
             formControlName="term"
             #searchInput/>
    </form>
    <div @searchLoaderAnim
         *ngIf="goSearchService.showLoader"
         class="go-search__loader-container">
      <go-loader class="go-search__loader" loaderSize="small"></go-loader>
    </div>
    <div class="go-search__results"
         @searchResultsAnim
         (@searchResultsAnim.start)="resultsStarted($event)"
         (@searchResultsAnim.done)="resultsEnded($event)"
         [ngStyle]="{ 'overflow-y': resultsOverflow }"
         *ngIf="goSearchService.hasResults && !goSearchService.showLoader">
      <ng-content></ng-content>
    </div>
    <div class="go-search__results go-search__results--none"
         @searchResultsAnim
         (@searchResultsAnim.start)="resultsStarted($event)"
         (@searchResultsAnim.done)="resultsEnded($event)"
         [ngStyle]="{ 'overflow-y': resultsOverflow }"
         *ngIf="goSearchService.showNoResultsMessage">
      {{ goSearchService.noResultsMessage }}
    </div>
  </div>
</div>